module.exports = __webpack_public_path__ + "img/dsci0088.269f9d85.jpg";